const colors = {
  transparent: 'transparent',
  black: '#000000',
  lapel: '#333333',
  matterhorn: '#555555',
  charcoal: '#767676',
  cultured: '#F5F5F5',
  'dusty-gray': '#999999',
  wolf: '#bbbbbb',
  alto: '#dddddd',
  dove: '#EEEEEE',
  gallery: '#F9F9F9',
  white: '#ffffff',
  'dark-blue': '#00479E',
  gatsby: '#005ac8',
  'panna-cotta': '#fff7ec',
  paloma: '#ff8669',
  platinum: '#E9E6E1',
  facebook: '#1877f2',
  error: '#f55c70',
  'error-background': '#fde3e7',
  success: '#00ad2e',
  'success-background': '#e2f5e3',
  bleach: '#EAE0CC',
  'dawn-pink': '#EAD7CC',
  'hint-of-red': '#F5EEEA',
  'hawkes-blue': '#CBD8E6',
  'white-ice': '#CCF9E3',
};

// tailwind.config.js can't import ES6 modules
// export this file as a commonJS module.
module.exports = colors;
